
import Backdrop from "@nodes/@material-ui/core/Backdrop";
import CircularProgress from "@nodes/@material-ui/core/CircularProgress";
import { makeStyles, createStyles } from "@nodes/@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
  })
);

const FullLoadingScreen = () => {
  const classes = useStyles();

  return (
    <div>
      <Backdrop className={classes.backdrop} open={true}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default FullLoadingScreen;
